import { NgModule } from '@angular/core';
import { CdkTableModule } from '@angular/cdk/table';

import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatFormFieldModule, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTreeModule } from '@angular/material/tree';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatRadioModule } from '@angular/material/radio';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSnackBarModule } from '@angular/material/snack-bar';

const modules = [
	CdkTableModule,
	MatMenuModule,
	MatButtonModule,
	MatButtonToggleModule,
	MatIconModule,
	MatCardModule,
	MatTabsModule,
	MatSidenavModule,
	MatListModule,
	MatToolbarModule,
	MatTooltipModule,
	MatInputModule,
	MatTableModule,
	MatPaginatorModule,
	MatSortModule,
	MatProgressSpinnerModule,
	MatStepperModule,
	MatDialogModule,
	MatButtonModule,
	MatIconModule,
	MatDividerModule,
	MatProgressSpinnerModule,
	MatGridListModule,
	MatFormFieldModule,
	MatSelectModule,
	MatAutocompleteModule,
	MatTreeModule,
	MatCheckboxModule,
	MatNativeDateModule,
	MatRippleModule,
	MatChipsModule,
	MatBadgeModule,
	MatExpansionModule,
	MatProgressBarModule,
	MatRadioModule,
	MatSliderModule,
	MatSlideToggleModule,
	MatDatepickerModule,
	MatSnackBarModule
];

@NgModule({
	imports: modules,
	providers: [{ provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'fill' } }],
	exports: modules,
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MaterialModule { }
